import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
`;

import {
  confirmDeleteWorkerText,
  confirmSoftDeleteWorkerText,
  constructStripeNegativeBalanceText,
  errorFetchingBalanceText,
} from "./modalMessage";
function StripeAccountDeletionModalText({ pageLoading, isError, balance }) {
  const [message, setMessage] = useState(confirmDeleteWorkerText);
  const isStripeBalanceNegative = balance.actualBalance < 0;
  useEffect(() => {
    if (isStripeBalanceNegative) {
      setMessage(constructStripeNegativeBalanceText(balance));
    } else if (isError) {
      setMessage(errorFetchingBalanceText);
    } else {
      setMessage(confirmSoftDeleteWorkerText);
    }
  }, [isError, balance, isStripeBalanceNegative]);

  return <Container>{pageLoading ? <Spin /> : message}</Container>;
}
export { StripeAccountDeletionModalText };
